/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import config from "../../app/config";

let styles;

(async () => {
  if (config.isWestJetMode) {
    styles = await import("./FaqSearchResultVwq.module.scss");
  } else {
    styles = await import("./FaqSearchResult.module.scss");
  }
})();

const ResultList = ({ currentResults, searchText, helpfulInfoSections, setSelectedInfo, setSelectedSection, setShowSearchResult }) => {

  const handleClick = (result) => {

    let selectedInfo;
    let selectedSection;
    
    helpfulInfoSections.forEach(category => {
      category.componentsCollection.forEach(info => {
        if(info.displayTitle === result.section){
          selectedInfo = info;
          selectedSection = category;
        }
      })
    })
    setSelectedInfo(selectedInfo);
    setSelectedSection(selectedSection);
    setShowSearchResult(false);

  };

  return (
    <ul>
      {currentResults.map((result) => (
        <li className={styles.listGroup}>
          <button onClick={(post) => handleClick(result)} className={styles.InfoButton}>
            <div className={styles.listGroupSection}>{result.section}</div>
            <div className={styles.listGroupText} 
              dangerouslySetInnerHTML={{
                __html: result.text.replace(searchText, "<b>" + searchText + "</b>"),
              }}
            ></div>
          </button>
        </li>
      ))}
    </ul>
  );
};


export default ResultList;